import { URL_OPCOES_RESTRICAO } from "../constantes";

export const urlOpcoesRestricao = (tipo) => `${URL_OPCOES_RESTRICAO}/${encodeURIComponent(tipo)}`;

export const urlBuscaRestricao = (tipo, termo) => `${urlOpcoesRestricao(tipo)}?q=${encodeURIComponent(String(termo === null || termo === undefined ? "" : termo))}`;

export const chaveRotulo = (tipo, chave) => `${tipo}|${chave}`;

export const mapearOpcaoRestricao = (opcao) => ({ id: String(opcao.chave), descricao: opcao.label || "" });

export function itensDaResposta(json) {
  const itens = json && json.data !== undefined ? json.data : json;

  return Array.isArray(itens) ? itens.filter((item) => item && item.chave !== null && item.chave !== undefined) : [];
}

export function rotuloDaChave(json, chave) {
  const encontrada = itensDaResposta(json).find((item) => String(item.chave) === String(chave));

  return encontrada && encontrada.label ? encontrada.label : null;
}

export const LIMITE_BUSCAS_SIMULTANEAS = 5;

export function restricoesSemRotulo(restricoes, rotulos) {
  const vistas = {};

  return (restricoes || []).filter((restricao) => {
    const chave = chaveRotulo(restricao.tipo, restricao.chave);

    if (vistas[chave] || (rotulos && Object.prototype.hasOwnProperty.call(rotulos, chave))) return false;

    vistas[chave] = true;

    return true;
  });
}

export function executarComLimite(tarefas, limite = LIMITE_BUSCAS_SIMULTANEAS) {
  const fila = [...tarefas];
  const trabalhador = () => {
    const tarefa = fila.shift();

    if (!tarefa) return Promise.resolve();

    return Promise.resolve()
      .then(tarefa)
      .catch(() => null)
      .then(trabalhador);
  };

  return Promise.all(Array.from({ length: Math.min(Math.max(limite, 1), fila.length) }, trabalhador)).then(() => undefined);
}

export function carregarRotulosRestricoes(restricoes, rotulos, definir, buscar, limite = LIMITE_BUSCAS_SIMULTANEAS) {
  const pendentes = restricoesSemRotulo(restricoes, rotulos);

  pendentes.forEach((restricao) => definir(chaveRotulo(restricao.tipo, restricao.chave), null));

  return executarComLimite(
    pendentes.map((restricao) => () =>
      buscar(urlBuscaRestricao(restricao.tipo, restricao.chave)).then((json) => {
        const rotulo = rotuloDaChave(json, restricao.chave);

        if (rotulo) definir(chaveRotulo(restricao.tipo, restricao.chave), rotulo);
      })
    ),
    limite
  );
}

export function descricaoRestricao(restricao, rotulos) {
  const rotulo = rotulos && rotulos[chaveRotulo(restricao.tipo, restricao.chave)];

  return rotulo && rotulo !== `${restricao.chave}` ? `${restricao.chave} - ${rotulo}` : `${restricao.chave}`;
}
